import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* resetUserPasswordSuccessAsync() {
    yield put(showNotification('notifications.users.password.success', 'success'));
}

function* failureMessage() {
    yield put(showNotification('notifications.users.password.failure', 'warning'));
}

export default function* usersSagas() {
    yield [
        takeEvery(types.RESET_USER_PASSWORD_FAILURE, failureMessage),
        takeEvery(types.RESET_USER_PASSWORD_SUCCESS, resetUserPasswordSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/usersPasswordSagas.js